import React, { useEffect, useState } from "react";
import "./Home.css";

import Banner from "../../Components/Banner/Banner";
import AboutComp from "../../Components/AboutComp/AboutComp";
import Pathway from "../../Components/Pathway/Pathway";
import Chooseus from "../../Components/Chooseus/Chooseus";
import Founder from "../../Components/Founder/Founder";
import GalleryComp from "../../Components/Gallery/GalleryComp.js";

import SchoolLife from "../../Components/SchoolLife/SchoolLife.js";
import Facilities from "../../Components/Facilities/Facilities.js";
import RecentEvents from "../../Components/RecentEvents/RecentEvents.js";
import UpcomingEvent from "../../Components/UpcomingEvent/UpcomingEvent.js";
import { useNavigate } from "react-router-dom";
import Host from "../../Host/Host.js";
import Loader from "../../Components/Loader/Loader.js";
import { useDispatch, useSelector } from "react-redux";
import {
  getAboutPage,
  getGallery,
  getHero,
  getHomePage,
  getProgramsPage,
} from "../../Redux/Slices/AppSlices.js";
import NewBanner from "../../Components/NewBanner/NewBanner.js";

const Home = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { hero, homePage, aboutPage, programsPage, gallery, loading } =
    useSelector((state) => state.app);

  useEffect(() => {
    dispatch(getHero());
    dispatch(getHomePage());
    dispatch(getAboutPage());
    dispatch(getProgramsPage());
    dispatch(getGallery());
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      {/* Hero Section */}
      {/* <Banner hero={hero} /> */}
      <NewBanner hero={hero}/>

      {/* About */}
      <div className="landing-pages">
        <AboutComp data={aboutPage?.aboutIntro} />
      </div>

      {/* Learning Pathway */}
      <Pathway
        title={homePage?.educationalProgramsTitle}
        program={programsPage?.programs}
      />

      {/* School Life / Activities */}
      <div className="landing-pages">
        <SchoolLife data={homePage} gallery={gallery}/>
      </div>
      {/* Facilities */}
      <Facilities data={homePage} />

      {/* Recent Events */}
      <div className="landing-pages">
        <RecentEvents data={homePage} gallery={gallery}/>
      </div>

      {/* Upcoming Event */}
      <UpcomingEvent data={homePage} />

      {/* Why Choose Us */}
      <div className="landing-pages">
        <Chooseus data={homePage} />
      </div>

      {/* Founder */}
      <Founder data={homePage} />

      {/* Gallery Preview */}
      <GalleryComp data={homePage} gallery={gallery}/>
    </>
  );
};

export default Home;
